export const getFreeGiftProductByProductSku = `
    query getFreeGiftProductByProductSku(
        $sku: String!
      ){
        mpFreeGiftsByProductSku (sku: $sku){
            auto_add
            gifts {
                added
                configurable
                final_price
                free_ship
                gift_price
                id
                image
                name
                required_option
                sku
            }
            max_gift
            notice
            rule_id
            total_added
            banner_config {
                position
                image_width
                image_height
                show_next_prev_buttons
                show_dots
                auto_play
                auto_timeout
                images {
                    position
                    url
                    alt
                    resolution
                }
            }
        }
    }
`;
